'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

var _PricePer = require('./PricePer.jsx');

var _PricePer2 = _interopRequireDefault(_PricePer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TotalDetails(props) {
  var perPassenger = props.perPassenger,
      total = props.total,
      components = props.components,
      selectedCurrencyFormat = props.selectedCurrencyFormat;


  var styleApproximatePtcValue = {
    color: components.ApproximatePtcValue.color,
    fontSize: components.ApproximatePtcValue.fontSize,
    fontWeight: components.ApproximatePtcValue.fontWeight,
    fontStyle: components.ApproximatePtcValue.fontStyle,
    textDecoration: components.ApproximatePtcValue.textDecoration,
    fontFamily: components.ApproximatePtcValue.fontFamily
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TotalDetails' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { verticalAlign: 'top', padding: '0', width: '70%' } },
          _react2.default.createElement(_PricePer2.default, { ptcs: perPassenger })
        ),
        _react2.default.createElement(
          'td',
          { style: { verticalAlign: 'top', padding: '0', textAlign: 'left', width: '30%' } },
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, styleApproximatePtcValue) },
            (0, _priceString2.default)(selectedCurrencyFormat, total.priceData.totalPrice + total.priceData.markupAmount + total.priceData.feeAmount + total.priceData.obFeeAmount || 0, total.priceData.currency)
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    selectedCurrencyFormat: state.rendering.shopOptions.currencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(TotalDetails);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/TotalDetails.jsx
// module id = 1487
// module chunks = 0